import type { IconIndicatorProps } from "./icon-indicator.type";

import { Flex, Typography } from "antd";
import classNames from "classnames";

import { IconCustom } from "@/ui/icon-custom";

import { IconIndicatorTooltip } from "./icon-indicator-tooltip";
import { useIndicatorIcon } from "./icon-indicator.hook";

import "./icon-indicator.style.less";

export const IconIndicator = (props: IconIndicatorProps) => {
  const { type, noTooltip, label, isBig } = props;
  const { iconExists, style } = useIndicatorIcon(props);

  if (!iconExists) return null;

  const icon = noTooltip ? (
    <IconCustom type={type} style={style} />
  ) : (
    <IconIndicatorTooltip {...props}>
      <IconCustom type={type} style={style} />
    </IconIndicatorTooltip>
  );

  if (!label) return icon;

  return (
    <Flex
      vertical
      align="center"
      gap={0}
      className={classNames("icon-indicator-with-label", { "-isBig": isBig })}
    >
      {icon}
      <Typography.Text className="icon-indicator-label">
        {label}
      </Typography.Text>
    </Flex>
  );
};
